/** Where to send a user after sign-in. Only same-origin /admin paths are
 *  honoured, so a crafted location.state can't redirect off-site (#990). */
export function safeReturnPath(from: unknown): string {
  if (typeof from !== "string") return "/admin";
  if (!/^\/admin(?:[/?#]|$)/.test(from)) return "/admin";
  // eslint-disable-next-line no-control-regex
  if (/[\\\u0000-\u001f\u007f]/.test(from) || from.includes("//")) return "/admin";
  if (/(^|\/)\.{1,2}(\/|$|[?#])/.test(from)) return "/admin";
  return from;
}
